export const EDIT_CUSTOMER= 'EDIT_CUSTOMER';
export const DELETE_CUSTOMER= 'DELETE_CUSTOMER';
export const ADD_CUSTOMER= 'ADD_CUSTOMER';
export const GET_CUSTOMERS= 'GET_CUSTOMERS';
export const LOAD_CUSTOMERS = 'LOAD_CUSTOMERS';
export const UPDATE_CUSTOMER = 'UPDATE_CUSTOMER';
